module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Pesquisa'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/pesquisa/consulta-projetos"
    }
  }, [_c('a', [_vm._v("Consultar Projetos de Pesquisa")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "pesquisa/novo-projeto"
    }
  }, [_c('a', [_vm._v("Novo Projeto de Pesquisa")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "pesquisa/meus-projetos"
    }
  }, [_c('a', [_vm._v("Meus Projetos de Pesquisa")])])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-117d5794","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ajuda/pesquisa.vue
// module id = 659
// module chunks = 0